import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import ThemeToggle from './components/ThemeToggle';
import Footer from './components/Footer';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import Register from './pages/Register';
import ChangePassword from './pages/ChangePassword';
import EditProfile from './pages/EditProfile';
import BulkEmail from './pages/BulkEmail';
import MyOrders from './pages/MyOrders';

// Camp Pages
import CampCenter from './modules/Camp/pages/CampCenter';
import CampSelection from './modules/Camp/pages/CampSelection';
import CampLogin from './modules/Camp/pages/CampLogin';
import CampRegistration from './modules/Camp/pages/CampRegistration';
import CampPayment from './modules/Camp/pages/CampPayment';

// Retreat Pages
import RetreatCenter from './modules/Retreat/pages/RetreatCenter';
import RetreatSelection from './modules/Retreat/pages/RetreatSelection';
import RetreatRegistration from './modules/Retreat/pages/RetreatRegistration';
import RetreatPayment from './modules/Retreat/pages/RetreatPayment';

// Class Pages
import ClassCenter from './modules/Class/pages/ClassCenter';
import ClassCategory from './modules/Class/pages/ClassCategory';
import ClassSelection from './modules/Class/pages/ClassSelection';
import EnrollStudent from './modules/Class/pages/EnrollStudent';
import OrderSummary from './modules/Class/pages/OrderSummary';
import Payment from './modules/Class/pages/Payment';
import ClassRegistration from './modules/Class/pages/ClassRegistration';

// Volunteer Pages
import VolunteerRegistration from './modules/Volunteer/pages/VolunteerRegistration';
import VolunteerSummerCamp from './modules/Volunteer/pages/VolunteerSummerCamp';

// YK Visit Pages
import YkVisitCenter from './modules/YkVisit/pages/YkVisitCenter';
import YkVisitSelection from './modules/YkVisit/pages/YkVisitSelection';
import YkVisitRegistration from './modules/YkVisit/pages/YkVisitRegistration';

// Tiffin Pages
import TiffinCenter from './modules/Tiffin/pages/TiffinCenter';
import TiffinSelection from './modules/Tiffin/pages/TiffinSelection';
import TiffinRegistration from './modules/Tiffin/pages/TiffinRegistration';
import TiffinMenu from './modules/Tiffin/pages/TiffinMenu';
import TiffinPayment from './modules/Tiffin/pages/TiffinPayment';
import TiffinSuccess from './modules/Tiffin/pages/TiffinSuccess';
import TiffinAdmin from './modules/Tiffin/pages/TiffinAdmin';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function App() {
  const [userCountry, setUserCountry] = useState('USA');

  useEffect(() => {
    fetch(`${API_BASE}/ykrestapi/CampChannel/GetCenter`, { method: 'GET' }).catch(() => {});
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-50">
        <Navigation userCountry={userCountry} setUserCountry={setUserCountry} />
        
        <main className="flex-grow">
          <Routes>
            {/* Home */}
            <Route path="/" element={<Home />} />

            {/* Registration */}
            <Route path="/register" element={<Register />} />

            {/* Forgot Password */}
            <Route path="/forgot-change-password" element={<ChangePassword />} />

            {/* Edit Profile */}
            <Route path="/profile" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />

            {/* My Orders */}
            <Route path="/orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />

            {/* Bulk Email */}
            <Route path="/email" element={<BulkEmail />} />

            {/* Camp Routes */}
            <Route path="/camp/center" element={<CampCenter />} />
            <Route path="/camp/selection" element={<CampSelection />} />
            <Route path="/camp/login" element={<CampLogin />} />
            <Route path="/camp/registration" element={<ProtectedRoute><CampRegistration /></ProtectedRoute>} />
            <Route path="/camp/payment" element={<ProtectedRoute><CampPayment /></ProtectedRoute>} />

            {/* Retreat Routes */}
            <Route path="/retreat/center" element={<RetreatCenter />} />
            <Route path="/retreat/selection" element={<RetreatSelection />} />
            <Route path="/retreat/registration" element={<ProtectedRoute><RetreatRegistration /></ProtectedRoute>} />
            <Route path="/retreat/payment" element={<ProtectedRoute><RetreatPayment /></ProtectedRoute>} />

            {/* Class Routes */}
            <Route path="/class/center" element={<ClassCenter />} />
            <Route path="/class/category" element={<ClassCategory />} />
            <Route path="/class/selection" element={<ClassSelection />} />
            <Route path="/class/enroll-student" element={<ProtectedRoute><EnrollStudent /></ProtectedRoute>} />
            <Route path="/class/order-summary" element={<ProtectedRoute><OrderSummary /></ProtectedRoute>} />
            <Route path="/class/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
            <Route path="/class/registration" element={<ProtectedRoute><ClassRegistration /></ProtectedRoute>} />

            {/* Tiffin Routes */}
            <Route path="/tiffin/center" element={<TiffinCenter />} />
            <Route path="/tiffin/selection" element={<TiffinSelection />} />
            <Route path="/tiffin/registration" element={<ProtectedRoute><TiffinRegistration /></ProtectedRoute>} />
            <Route path="/tiffin/menu" element={<TiffinMenu />} />
            <Route path="/tiffin/payment" element={<TiffinPayment />} />
            <Route path="/tiffin/success" element={<TiffinSuccess />} />
            <Route path="/tiffin/admin" element={<TiffinAdmin />} />

            {/* YK Visit Routes */}
            <Route path="/yk-visit/center" element={<YkVisitCenter />} />
            <Route path="/yk-visit/selection" element={<YkVisitSelection />} />
            <Route path="/yk-visit/registration" element={<ProtectedRoute><YkVisitRegistration /></ProtectedRoute>} />

            {/* Volunteer Routes */}
            <Route path="/volunteer/register" element={<VolunteerRegistration />} />
            <Route path="/volunteer/summer-camp" element={<VolunteerSummerCamp />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
        <ThemeToggle />
      </div>
    </Router>
  );
}

export default App;
